 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"AdminSettings~AwardForm~AwardManagement~AwardTypeManagement~AwardTypes~ConferenceManagement~Nominati~6dfd3d30":"AdminSettings~AwardForm~AwardManagement~AwardTypeManagement~AwardTypes~ConferenceManagement~Nominati~6dfd3d30","AdminSettings":"AdminSettings","AwardForm~AwardManagement~AwardTypeManagement~ConferenceManagement~NominationForm~NominationResults~~718f76a3":"AwardForm~AwardManagement~AwardTypeManagement~ConferenceManagement~NominationForm~NominationResults~~718f76a3","AwardForm~NominationForm":"AwardForm~NominationForm","NominationForm":"NominationForm","AwardForm~NominationResults~ViewBallot~VotingResults":"AwardForm~NominationResults~ViewBallot~VotingResults","AwardForm":"AwardForm","NominationResults":"NominationResults","ViewBallot":"ViewBallot","VotingResults":"VotingResults","AwardManagement":"AwardManagement","AwardTypeManagement~StatGroupManagement~StatManagement":"AwardTypeManagement~StatGroupManagement~StatManagement","AwardTypeManagement":"AwardTypeManagement","StatGroupManagement":"StatGroupManagement","StatManagement~Vote":"StatManagement~Vote","StatManagement":"StatManagement","ConferenceManagement":"ConferenceManagement","SelectAward":"SelectAward","Vote":"Vote","VoterMaintenance":"VoterMaintenance","Voting":"Voting","AwardTypes":"AwardTypes","StatGroups":"StatGroups","VoterPreferences":"VoterPreferences"}[chunkId]||chunkId) + "." + {"AdminSettings~AwardForm~AwardManagement~AwardTypeManagement~AwardTypes~ConferenceManagement~Nominati~6dfd3d30":"b649f4aa","AdminSettings":"55cd4601","AwardForm~AwardManagement~AwardTypeManagement~ConferenceManagement~NominationForm~NominationResults~~718f76a3":"b1f1040a","AwardForm~NominationForm":"c07add1e","NominationForm":"ebf7a177","AwardForm~NominationResults~ViewBallot~VotingResults":"d1d449aa","AwardForm":"370a9471","NominationResults":"53d580fc","ViewBallot":"c88fb24b","VotingResults":"1e0ea855","AwardManagement":"b1ccd26f","AwardTypeManagement~StatGroupManagement~StatManagement":"a15fd21f","AwardTypeManagement":"7fac42a3","StatGroupManagement":"d01b3b65","StatManagement~Vote":"1a54dba6","StatManagement":"47c5cdfa","ConferenceManagement":"c414c95a","SelectAward":"b8cad103","Vote":"04222b58","VoterMaintenance":"6203f06e","Voting":"9a70d2c4","AwardTypes":"09102fcc","StatGroups":"381a02b3","VoterPreferences":"9c53f9da","chunk-2d216214":"d1798ce6","chunk-2d216257":"58872a85","chunk-4d92710d":"7441538f"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"AdminSettings~AwardForm~AwardManagement~AwardTypeManagement~AwardTypes~ConferenceManagement~Nominati~6dfd3d30":1,"AdminSettings":1,"AwardForm~AwardManagement~AwardTypeManagement~ConferenceManagement~NominationForm~NominationResults~~718f76a3":1,"AwardForm~NominationForm":1,"NominationForm":1,"AwardForm~NominationResults~ViewBallot~VotingResults":1,"AwardForm":1,"NominationResults":1,"ViewBallot":1,"VotingResults":1,"AwardManagement":1,"AwardTypeManagement~StatGroupManagement~StatManagement":1,"StatManagement":1,"ConferenceManagement":1,"SelectAward":1,"Vote":1,"VoterMaintenance":1,"Voting":1,"AwardTypes":1,"StatGroups":1,"VoterPreferences":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"AdminSettings~AwardForm~AwardManagement~AwardTypeManagement~AwardTypes~ConferenceManagement~Nominati~6dfd3d30":"AdminSettings~AwardForm~AwardManagement~AwardTypeManagement~AwardTypes~ConferenceManagement~Nominati~6dfd3d30","AdminSettings":"AdminSettings","AwardForm~AwardManagement~AwardTypeManagement~ConferenceManagement~NominationForm~NominationResults~~718f76a3":"AwardForm~AwardManagement~AwardTypeManagement~ConferenceManagement~NominationForm~NominationResults~~718f76a3","AwardForm~NominationForm":"AwardForm~NominationForm","NominationForm":"NominationForm","AwardForm~NominationResults~ViewBallot~VotingResults":"AwardForm~NominationResults~ViewBallot~VotingResults","AwardForm":"AwardForm","NominationResults":"NominationResults","ViewBallot":"ViewBallot","VotingResults":"VotingResults","AwardManagement":"AwardManagement","AwardTypeManagement~StatGroupManagement~StatManagement":"AwardTypeManagement~StatGroupManagement~StatManagement","AwardTypeManagement":"AwardTypeManagement","StatGroupManagement":"StatGroupManagement","StatManagement~Vote":"StatManagement~Vote","StatManagement":"StatManagement","ConferenceManagement":"ConferenceManagement","SelectAward":"SelectAward","Vote":"Vote","VoterMaintenance":"VoterMaintenance","Voting":"Voting","AwardTypes":"AwardTypes","StatGroups":"StatGroups","VoterPreferences":"VoterPreferences"}[chunkId]||chunkId) + "." + {"AdminSettings~AwardForm~AwardManagement~AwardTypeManagement~AwardTypes~ConferenceManagement~Nominati~6dfd3d30":"5b795bac","AdminSettings":"726b3234","AwardForm~AwardManagement~AwardTypeManagement~ConferenceManagement~NominationForm~NominationResults~~718f76a3":"daca5a6e","AwardForm~NominationForm":"71de997d","NominationForm":"33f9902c","AwardForm~NominationResults~ViewBallot~VotingResults":"bcd35645","AwardForm":"c760e261","NominationResults":"714aaa06","ViewBallot":"8806a3bd","VotingResults":"3e9a36bd","AwardManagement":"baac75f0","AwardTypeManagement~StatGroupManagement~StatManagement":"0d33a3f5","AwardTypeManagement":"31d6cfe0","StatGroupManagement":"31d6cfe0","StatManagement~Vote":"31d6cfe0","StatManagement":"7a214350","ConferenceManagement":"e39d1476","SelectAward":"438637a1","Vote":"dda31944","VoterMaintenance":"4808febe","Voting":"297d45b6","AwardTypes":"726b3234","StatGroups":"726b3234","VoterPreferences":"726b3234","chunk-2d216214":"31d6cfe0","chunk-2d216257":"31d6cfe0","chunk-4d92710d":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
